import { FlowGraphExecutionBlock } from "core/FlowGraph/flowGraphExecutionBlock";
import { getRichTypeByFlowGraphType } from "core/FlowGraph/flowGraphRichTypes.pure";
import { FlowGraphInteger } from "core/FlowGraph/CustomTypes/flowGraphInteger.pure";
import { FlowGraphMatrix2D, FlowGraphMatrix3D } from "core/FlowGraph/CustomTypes/flowGraphMatrix";
import { Matrix, Vector2, Vector3, Vector4 } from "core/Maths/math.vector.pure";
function _GetDefaultValue(signature) {
    switch (signature) {
        case "bool":
            return false;
        case "int":
            return new FlowGraphInteger(0);
        case "float":
            return NaN;
        case "float2":
            return new Vector2(NaN, NaN);
        case "float3":
            return new Vector3(NaN, NaN, NaN);
        case "float4":
            return new Vector4(NaN, NaN, NaN, NaN);
        case "float2x2":
            return new FlowGraphMatrix2D([NaN, NaN, NaN, NaN]);
        case "float3x3":
            return new FlowGraphMatrix3D([NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN]);
        case "float4x4":
            return Matrix.FromArray([NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN, NaN]);
        case "ref":
            return "";
        default:
            return undefined;
    }
}
/**
 * Inspectable runtime no-op for an operation owned by an unsupported glTF extension.
 */
export class FlowGraphUnsupportedInteractivityBlock extends FlowGraphExecutionBlock {
    constructor(config) {
        super(config);
        this.config = config;
        this._unregisterSignalInput("in");
        this._unregisterSignalOutput("error");
        for (const socket of config.inputValueSockets ?? []) {
            this.registerDataInput(socket.name, getRichTypeByFlowGraphType(socket.type));
        }
        for (const socket of config.outputValueSockets ?? []) {
            this.registerDataOutput(socket.name, getRichTypeByFlowGraphType(socket.type), _GetDefaultValue(socket.signature));
        }
        for (const socket of config.inputFlowSockets ?? []) {
            this._registerSignalInput(socket);
        }
        for (const socket of config.outputFlowSockets ?? []) {
            this._registerSignalOutput(socket);
        }
    }
    /** @internal */
    _execute(_context, _callingSignal) {
        // Unsupported extension operations are required to behave as no-ops.
    }
    /** @returns the serialized class name */
    getClassName() {
        return "FlowGraphUnsupportedInteractivityBlock";
    }
}
//# sourceMappingURL=flowGraphUnsupportedInteractivityBlock.js.map